import Home from '../home'

/**
 * Home da visão do produtor. Mesma tela do aluno; a home detecta o preview e
 * troca a fonte dos produtos (adminPreviewProducts em vez das matrículas).
 * No legado o equivalente é /courses, servido pelo core só para colaborador.
 */
export default function AdminViewHome() {
  return <Home />
}
